import type { FaireProductEntity } from "../../entity_types/product";

export const p_kw4wyrbg4g: FaireProductEntity = {
  token: "p_kw4wyrbg4g",
  type: "product",
  name: "Koi Fish Hand-Painted Porcelain Mug with Saucer Lid – 13 oz",
  brandToken: "b_m8c3mbnsfa",
  brandName: "Urban Tokyo",
  imageUrl: "https://cdn.faire.com/fastly/94725087ebcb96297c85c8f24a71ee78dbbe637bdb15ec861e0a88ab98a62df2.png",
  galleryImageUrls: [],
  priceDollars: 7.5,
  description: "Enjoy coffee or tea in this 13 oz footed porcelain mug with a hand-painted koi fish design and a matching saucer lid. A red koi leaps through blue and white waves on a soft sage gray body, with a matching foot, handle and lid. The matching lid sits on top of the mug and doubles as a small saucer. Microwave and dishwasher safe, it is built for cafés, restaurants and gift shops, and looks just as good on the kitchen counter at home. A thoughtful gift for tea and coffee lovers.\n\nFeatures\n\n * Hand-painted: each design is painted by hand, so every mug has its own character \n * Saucer lid: a matching lid that doubles as a small saucer \n * Footed shape: a raised foot and a comfortable handle \n * Easy care: microwave and dishwasher safe \nSpecifications\n\n * Size: 4\" H \n * Capacity: 13 fl oz \n * Material: Porcelain \n * Decoration: Hand-painted \n * Design: Koi Fish \n * Includes: Mug and saucer lid \n * Inner pack: 4 \n * Case pack: 32 \n * Origin: China \n * Care: Microwave and dishwasher safe. ",
  tags: [],
  msrpDollars: 16.87,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:49.152Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
